'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeCircle = function makeCircle(radius, color) {
  return {
    width: radius + 'px',
    height: radius + 'px',
    backgroundColor: color,
    borderRadius: radius / 2 + 'px',
    cursor: 'pointer',
    position: 'absolute',
    bottom: radius / 2 + 'px',
    right: radius / 2 + 'px'
  };
};

var Record = function Record(_ref) {
  var getRecordingStatus = _ref.getRecordingStatus;
  var _onClick = _ref.onClick;
  var onMouseOver = _ref.onMouseOver;
  var onMouseOut = _ref.onMouseOut;
  var hovered = _ref.hovered;

  var style = makeCircle(50, 'gainsboro');
  style.boxShadow = '2px 2px 5px #888888';
  style.zIndex = 99;
  style.right = '100px';
  var innerCirlcleStyle = makeCircle(25, 'red');
  if (!hovered) {
    innerCirlcleStyle.opacity = 0.3;
  }
  return _react2.default.createElement(
    'div',
    {
      className: 'redux-test-recorder-record-button',
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      style: style,
      onClick: function onClick() {
        return _onClick(getRecordingStatus());
      }
    },
    _react2.default.createElement('div', { className: 'redux-test-recorder-record-button', style: innerCirlcleStyle })
  );
};

exports.default = Record;


/*****************
 ** WEBPACK FOOTER
 ** ./dist/record-component.js
 ** module id = 183
 ** module chunks = 0
 **/